import { useQuery } from "@tanstack/react-query";
import { faCirclePlus, faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { GameProposalOverviewAPI } from "../TestManagementApi";
import CompanyInfoCheckAPI from "../../Home/Data/CompanyInfoCheckAPI";
import  OngoingGameBox  from "./components/OngoingGameBox";
import ExpiredGameBox from "./components/ExpiredGameBox";
import OnWritingGameBox from "./components/OnWritingGameBox";

export interface DraftGame {
  gameProposalId: number;
  status: 'IN_PROGRESS' | 'SUBMITTED' | 'REJECTED' | 'APPROVED';
  title: string;
  bannerUrl: string;
}

interface OngoingGame {
  gameProposalId: number;
  gameId: number;
  title: string;
  bannerUrl: string;
  startedAt: string;
  expiredAt: string;
}

interface ExpiredGame {
  gameProposalId: number;
  gameId: number;
  title: string;
  bannerUrl: string;
  startedAt: string;
  expiredAt: string;
}

interface GameProposalOverviewResponse {
  draftGames: DraftGame[];
  ongoingGames: OngoingGame[];
  expiredGames: ExpiredGame[];
}

const Main = styled.main`
  background-color: #f8f9fa;
  width: 100%;
  padding-left: 280px;
  padding-top: 40px;
  overflow: hidden;

  height: 100%;
  padding-bottom: 200px;
  overflow-y: auto;
  height: calc(100vh - 200px);
`;

const Container = styled.div`
  padding: 0 40px 40px;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;

`;

const NoticeWrapper = styled.div`
  // width: 1280px;
  width: 90%;
  height: 110px;
  background-color: white;
  padding: 0px 40px;
  border-radius: 5px;
  margin-bottom: 50px;
  font-weight: 500;
  color: #555555;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
`;

const Notice = styled.span`
  font-weight: 500;
  color: #555555;
`;

const AuthSpan = styled.span`
  text-decoration: underline;
  color: #2282e9;
  font-weight: 500;
`;

const Title = styled.span`
  display: block;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
`;

const ContentBox = styled.div`
  border-radius: 5px;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 300px;
  min-width: 300px;
  flex-shrink: 0;
  cursor: ${props => props.onClick ? 'pointer' : 'default'};
`;

const ContentZeroSpan = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 30px;
  color: #c0c0c0;
  text-align: center;
`;

const GameBox = styled(ContentBox)`
  flex-direction: column;
  padding: 20px;
  justify-content: flex-end;
  align-items: flex-start;
  position: relative;
  background-color: white;
  // height: 0vh;
  // height: 400px;
`;

const GameOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 230px;
  background: linear-gradient(180deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.3) 30%, rgba(0,0,0,0) 100%);
  border-radius: 5px 5px 0 0;
`;

const BannerImage = styled.div<{ url: string }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 220px;
  background-image: 
    linear-gradient(180deg, rgba(255,255,255,0) 70%, rgba(255,255,255,1) 100%),
    ${({ url }) => `url(${url})`};
  background-size: cover;
  background-position: center;
  border-radius: 5px 5px 0 0;
`;

const GameTitle = styled.h3`
  color: black;
  font-size: 18px;
  font-weight: 600;
  z-index: 1;
  margin: 0 0 12px 0;
  position: relative;
  margin-top: 10px;
  padding-top: 20px;
  // padding-bottom: 20px;
`;

const StatusBadge = styled.div<{ status: string }>`
  
  top: 20px;
  left: 20px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  z-index: 2;
   margin-bottom: 12px;
  
  ${({ status }) => {
    switch (status) {
      case 'REJECTED':
        return `
          background-color: #FF1F00;
          color: white;
        `;
      case 'SUBMITTED':
        return `
          background-color: #797979;
          color: white;
        `;
      case 'APPROVED':
        return `
          background-color: #2282E9;
          color: white;
        `;

    }
  }}
`;

const ContentWrapper = styled.div`
  display: flex;
  gap: 20px;
  width: 90%;
  overflow-x: auto;
  margin-bottom: 50px;

`;

const ActionLink = styled(Link)`
  color: #9F9F9F;
  text-decoration: underline;
  font-size: 14px;
  font-weight: 500;
  z-index: 1;
  align-self: flex-start;

  &:hover {
    text-decoration: underline;
  }
`;

const GameDate = styled.p`
  color: #666666;
  font-size: 14px;
  margin: 0 0 12px 0;
  margin-top: 10px;
  z-index: 1;
    position: relative;
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;


const MoreButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  border: none;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #666666;
  z-index: 2;
  
  &:hover {
    background-color: #f5f5f5;
  }
`;

const DropdownMenu = styled.div<{ isVisible: boolean }>`
  position: absolute;
  top: 50px;
  right: -30px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
  z-index: 3;
`;

const MenuItem = styled.button`
  padding: 12px 16px;
  background: none;
  border: none;
  text-align: left;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  width: 100%;
  display: block;

  &:hover {
    background-color: #f5f5f5;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #f0f0f0;
  }
`;

const GameBoxContainer = styled.div`
  position: relative;
`;

const DefaultBanner = styled.div`
  position: absolute;
  top: 0%;
  left: 0;
  right: 0;
  height: 70%;
  background: linear-gradient(180deg, #E7E7E7 0%, #FEFEFE 100%);
  border-radius: 5px 5px 0 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  text-align: center;
`;

const DefaultText = styled.p`
  font-size: 15px;
  color: #999;
  margin: 0 0 0 0;
`;

interface GameBoxProps {
  game: OngoingGame;
}

const ContentInfo = styled.div`
  padding-top: 30px;
  margin-top: auto;
  height:42%;
  width: 100%;
`;

export default function TestList() {
  const { data: gameData } = useQuery<GameProposalOverviewResponse>({
    queryKey: ["GameProposalOverview"],
    queryFn: async () => {
      const response = await GameProposalOverviewAPI();
      return response.data;
    },
    // initialData: {
    //   draftGames: [
    //     {
    //       gameProposalId: 2,
    //       status: "IN_PROGRESS",
    //       title: "GAME_TITLE",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //     },
    //     {
    //       gameProposalId: 5,
    //       status: "IN_PROGRESS",
    //       title: "GAME_TITLE",
    //       bannerUrl: "",
    //     },
    //     {
    //       gameProposalId: 6,
    //       status: "IN_PROGRESS",
    //       title: "GAME_TITLE",
    //       bannerUrl: "",
    //     },
    //     {
    //       gameProposalId: 7,
    //       status: "IN_PROGRESS",
    //       title: "GAME_TITLE",
    //       bannerUrl: "",
    //     },
    //     {
    //       gameProposalId: 8,
    //       status: "IN_PROGRESS",
    //       title: "GAME_TITLE",
    //       bannerUrl: "",
    //     },
    //     {
    //       gameProposalId: 9,
    //       status: "IN_PROGRESS",
    //       title: "GAME_TITLE",
    //       bannerUrl: "",
    //     }
    //   ],
    //   ongoingGames: [
    //     {
    //       gameProposalId: 3,
    //       gameId: 16,
    //       title: "CBT_GAME_TITLE-0",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //       startedAt: "2025-02-28T00:00:00",
    //       expiredAt: "2025-03-14T00:00:00"
    //     },
    //     {
    //       gameProposalId: 3,
    //       gameId: 16,
    //       title: "CBT_GAME_TITLE-0",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //       startedAt: "2025-02-28T00:00:00",
    //       expiredAt: "2025-03-14T00:00:00"
    //     },
    //     {
    //       gameProposalId: 3,
    //       gameId: 16,
    //       title: "CBT_GAME_TITLE-0",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //       startedAt: "2025-02-28T00:00:00",
    //       expiredAt: "2025-03-14T00:00:00"
    //     },
    //     {
    //       gameProposalId: 3,
    //       gameId: 16,
    //       title: "CBT_GAME_TITLE-0",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //       startedAt: "2025-02-28T00:00:00",
    //       expiredAt: "2025-03-14T00:00:00"
    //     },
    //     {
    //       gameProposalId: 3,
    //       gameId: 16,
    //       title: "CBT_GAME_TITLE-0",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //       startedAt: "2025-02-28T00:00:00",
    //       expiredAt: "2025-03-14T00:00:00"
    //     },
    //     {
    //       gameProposalId: 3,
    //       gameId: 16,
    //       title: "CBT_GAME_TITLE-0",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //       startedAt: "2025-02-28T00:00:00",
    //       expiredAt: "2025-03-14T00:00:00"
    //     },
    //     {
    //       gameProposalId: 3,
    //       gameId: 16,
    //       title: "CBT_GAME_TITLE-0",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //       startedAt: "2025-02-28T00:00:00",
    //       expiredAt: "2025-03-14T00:00:00"
    //     },
    //   ],
    //   expiredGames: [
    //     {
    //       gameProposalId: 4,
    //       gameId: 17,
    //       title: "CBT_GAME_TITLE-0",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //       startedAt: "2024-11-28T00:00:00",
    //       expiredAt: "2024-12-12T00:00:00"
    //     },
    //     {
    //       gameProposalId: 4,
    //       gameId: 17,
    //       title: "CBT_GAME_TITLE-0",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //       startedAt: "2024-11-28T00:00:00",
    //       expiredAt: "2024-12-12T00:00:00"
    //     },
    //     {
    //       gameProposalId: 4,
    //       gameId: 17,
    //       title: "CBT_GAME_TITLE-0",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //       startedAt: "2024-11-28T00:00:00",
    //       expiredAt: "2024-12-12T00:00:00"
    //     },
    //     {
    //       gameProposalId: 4,
    //       gameId: 17,
    //       title: "CBT_GAME_TITLE-0",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //       startedAt: "2024-11-28T00:00:00",
    //       expiredAt: "2024-12-12T00:00:00"
    //     },
    //     {
    //       gameProposalId: 4,
    //       gameId: 17,
    //       title: "CBT_GAME_TITLE-0",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //       startedAt: "2024-11-28T00:00:00",
    //       expiredAt: "2024-12-12T00:00:00"
    //     },
    //     {
    //       gameProposalId: 4,
    //       gameId: 17,
    //       title: "CBT_GAME_TITLE-0",
    //       bannerUrl: "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png",
    //       startedAt: "2024-11-28T00:00:00",
    //       expiredAt: "2024-12-12T00:00:00"
    //     },
    //   ]
    // },
    enabled: true,
  });

  const { data: companyInfoCheckData } = useQuery({
    queryKey: ["companyInfoCheck"],
    queryFn: async () => {
      const response = await CompanyInfoCheckAPI();
      return response.data;
    },
    initialData: {
      everApproved: false,
    },
    enabled: true,
  });

  console.log(`companyInfoCheckData?.everApproved : ${companyInfoCheckData?.everApproved}`);
  const navigate = useNavigate();
  const showDashboard = (gameId: number) => {
    navigate(`/home/test-list/${gameId}/dashboard`);
  }

  const ongoingGames = gameData?.ongoingGames ?? [];
  const draftGames = gameData?.draftGames ?? [];
  const expiredGames = gameData?.expiredGames ?? [];

  return (
    <Main>
      <Container>
        {companyInfoCheckData?.everApproved === false && (
          <NoticeWrapper>
            <Notice>
              잠깐! 프로젝트 진행을 위해 반드시 게임사 인증이 필요합니다. 필요한
            자료 제출을 완료하셨을까요?
          </Notice>
          <Link to="/home/company-info">
            <AuthSpan>게임사 인증하기</AuthSpan>
            </Link>
          </NoticeWrapper>
        )}
        <>
          <TitleWrapper>
            <Title>작성 중인 게임 테스트</Title>
            <MoreButton>
              <FontAwesomeIcon icon={faEllipsisH} />
            </MoreButton>
          </TitleWrapper>
          <ContentWrapper>
            {draftGames.length > 0 ? (
              draftGames.map((game) => (
                <OnWritingGameBox key={game.gameProposalId} game={game} />
              ))
            ) : (
              <ContentBox onClick={() => navigate("/home/test-list/add")}>
                <ContentZeroSpan>
                  새로운 <br />
                  테스트 설계하기 <br />
                  <FontAwesomeIcon
                    icon={faCirclePlus}
                    style={{
                      width: "30px",
                      height: "30px",
                      marginTop: "20px",
                      color: "#e7e7e7",
                    }}

                  />
                </ContentZeroSpan>
              </ContentBox>
            )}
          </ContentWrapper>
        </>
        <>
          <TitleWrapper>
            <Title>진행 중인 게임 테스트</Title>
            <MoreButton>
              <FontAwesomeIcon icon={faEllipsisH} />
            </MoreButton>
          </TitleWrapper>
          <ContentWrapper>
            {ongoingGames.length > 0 ? (
              ongoingGames.map((game) => (
                <OngoingGameBox key={game.gameId} game={game} onClick={() => showDashboard(game.gameId)}/>
              ))
            ) : (
              <ContentBox>
                <ContentZeroSpan>
                  현재 진행 중인 <br />
                  테스트가 없습니다 :(
                </ContentZeroSpan>
              </ContentBox>
            )}
          </ContentWrapper>
        </>
        <>
          <TitleWrapper>
            <Title>종료된 게임 테스트</Title>
            <MoreButton>
              <FontAwesomeIcon icon={faEllipsisH} />
            </MoreButton>
          </TitleWrapper>
          <ContentWrapper>
            {expiredGames.length > 0 ? (
              expiredGames.map((game) => (
                <ExpiredGameBox key={game.gameId} game={game} />
              ))
            ) : (
              <ContentBox>
                <ContentZeroSpan>
                  현재 진행 중인 <br />
                  테스트가 없습니다 :(
                </ContentZeroSpan>
              </ContentBox>
            )}
          </ContentWrapper>
        </>
      </Container>
    </Main>
  );
}
